import type { LinksFunction, MetaFunction } from "react-router";
import { Links, Meta, Outlet, Scripts, ScrollRestoration } from "react-router";
import styles from "~/tailwind.css?url";
import { SYOPE_API_ORIGIN } from "~/http/syope";
import type { Route } from "./+types/root";

export const meta: MetaFunction = () => [
  {
    title: "Mon compte TILDEV",
  },
];

export const links: LinksFunction = () => [{ rel: "stylesheet", href: styles }];

export async function loader() {
  return {
    ENV: {
      SYOPE_API_ORIGIN,
    },
  };
}

export function ErrorBoundary({
    error
}: Route.ErrorBoundaryProps) {
  console.error(error);
  if (error instanceof Error) {
    return (
        <div>
          <h1>Error</h1>
          <p>{error.message}</p>
          <p>The stack trace is:</p>
          <pre>{error.stack}</pre>
        </div>
    );
  } else {
    return <div>Une erreur inattendue est survenue</div>;
  }
}

export default function App({ loaderData: data }: Route.ComponentProps) {
  return (
    <html lang="en" className="h-full bg-white">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body className="h-full">
        <Outlet />
        <ScrollRestoration />
        <script
          dangerouslySetInnerHTML={{
            __html: `window.ENV = ${JSON.stringify(data.ENV)}`,
          }}
        />
        <Scripts />
      </body>
    </html>
  );
}
